import { saveUserInput, useUserInput } from '@store';
import { useDispatch } from 'react-redux';

export const useSoftwareTerms = () => {
	const dispatch = useDispatch();
	const { acceptedTermsAndConditionsSoftware: termsWereAccepted, acceptedDebitInAccount: debitWasAccepted } =
		useUserInput();

	const acceptTerms = () => {
		dispatch(saveUserInput({ acceptedTermsAndConditionsSoftware: true }));
	};

	const acceptDebit = () => {
		dispatch(saveUserInput({ acceptedDebitInAccount: true }));
	};

	const refuseDebit = () => {
		dispatch(saveUserInput({ acceptedDebitInAccount: false }));
	};

	return { acceptTerms, acceptDebit, refuseDebit, termsWereAccepted, debitWasAccepted };
};
